module.exports = __webpack_public_path__ + "assets/img/login.b9907a2a.png";